import { render, staticRenderFns } from "./PortfolioMinimal.vue?vue&type=template&id=7b904d0c&"
import script from "./PortfolioMinimal.vue?vue&type=script&lang=js&"
export * from "./PortfolioMinimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports